import React, { FC, PropsWithChildren } from 'react';
import './Menu.css';

export const Menu: FC<PropsWithChildren> = ({ children }) => {
  return <div role="menu">{children}</div>;
};
